import React from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';

const DefaultStep = () => <div>{getText(TEXT_KEY.AN_UNEXPECTED_ERROR)}</div>;

export default DefaultStep;

